import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported } from 'firebase/messaging';

const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
const authDomain = process.env.REACT_APP_FIREBASE_PROJECT_ID + ".firebaseapp.com";
const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const storageBucket = process.env.REACT_APP_FIREBASE_PROJECT_ID + ".firebasestorage.app";
const messagingSenderId = process.env.REACT_APP_FIREBASE_SENDER_ID;
const appId = process.env.REACT_APP_FIREBASE_APP_ID;
const measurementId = process.env.REACT_APP_MEASUREMENT_ID;

const firebaseConfig = {
  apiKey: apiKey,
  authDomain: authDomain,
  projectId: projectId,
  storageBucket: storageBucket,
  messagingSenderId: messagingSenderId,
  appId: appId,
  measurementId: measurementId,
};

const app = initializeApp(firebaseConfig);

export const requestForToken = async () => {
  if (typeof window === 'undefined' || !(await isSupported())) {
    console.log('[Background Notification] Not supported in this browser.');
    return null;
  }

  // Ensure SW is registered (if your framework doesn’t auto-register it)
  await navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/' });

  // Wait until a SW is active and controlling this page
  // let reg = await navigator.serviceWorker.ready;
  // if (!navigator.serviceWorker.controller) {
  //   await new Promise<void>((resolve) =>
  //     navigator.serviceWorker.addEventListener('controllerchange', () => resolve(), { once: true })
  //   );
  //   reg = await navigator.serviceWorker.ready;
  // }
  const readyWithTimeout = <T>(p: Promise<T>, ms = 6000) =>
    new Promise<T>((resolve, reject) => {
      const t = setTimeout(() => reject(new Error('SW ready timeout')), ms);
      p.then(v => { clearTimeout(t); resolve(v); }, e => { clearTimeout(t); reject(e); });
    });

  let reg = await readyWithTimeout(navigator.serviceWorker.ready);

  // Check permission
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') {
    console.log('[Background Notification] Permission not granted.');
    return null;
  }

  const messaging = getMessaging(app);
  const getTokenAttempt = () =>
    getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_WEB_PUSH_CERTIFICATE_KEY, // VAPID public key
      serviceWorkerRegistration: reg,
    });

  try {
    const token = await getTokenAttempt();

    console.log('[Background Notification] Registration token retrieved successfully.');
    // if (token) {
    //   console.log('[Background Notification] current token for client:', token);
    // } else {
    //   console.log('[Background Notification] No registration token available. Request permission to generate one.');
    // }

    return token;
  } catch (err: any) {
    console.log('[Background Notification] An error occurred while retrieving token.', err);

    // One-time retry if we still raced activation
    if (err?.name === 'AbortError' || /no active Service Worker/i.test(String(err))) {
      await new Promise(r => setTimeout(r, 300));
      reg = await navigator.serviceWorker.ready;
      console.log('[Background Notification] An error occurred while retrieving token - retrying.');
      return await getTokenAttempt();
    }

    return null;
  }
};
